import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { clone } from 'ramda';
import commonResources from './common';
import supplyChainResources from './supply-chain';
import { DEFAULT_LOCALE, polyglotRegistry, readInitialLocale } from '../translate/polyglot-registry';

const EN = {
  common: { ...commonResources },
  supplyChain: { ...supplyChainResources }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: clone(EN) }
    },
    lng: readInitialLocale(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'b', 'p', 'a', 'u', 'strong', 'i', 'li', 'ul', 'ol', 'em', 'span']
    }
  });

// Lazy per-locale i18next bundles, loaded through polyglotRegistry so `ready()` drains them
// together with the Polyglot chunks. The registry only needs `replace(phrases)`, so we hand it
// an adapter that adds the resolved phrases to i18next for the boot locale.
// English is added synchronously — it's the fallback while the locale chunk loads, and xT()
// calls at module load must not see raw keys. It's cloned because i18next keeps references to
// what it's given and deep-merges later bundles into them, which would mutate the registry's
// `en` baseline used to build the other locales.
export const registerI18nBundle = ({ namespace, en, loaders }) => {
  const addBundle = (phrases, lng) =>
    i18n.addResourceBundle(lng, 'translation', namespace ? { [namespace]: phrases } : phrases, true, true);
  addBundle(clone(en), DEFAULT_LOCALE);
  polyglotRegistry.register({ replace: phrases => addBundle(phrases, polyglotRegistry.getLocale()) }, { en, loaders });
};

registerI18nBundle({
  en: EN,
  loaders: {
    es: () => import(/* webpackChunkName: "common-utils-i18n-locale-es" */ './locales/es'),
    fil: () => import(/* webpackChunkName: "common-utils-i18n-locale-fil" */ './locales/fil'),
    ja: () => import(/* webpackChunkName: "common-utils-i18n-locale-ja" */ './locales/ja'),
    th: () => import(/* webpackChunkName: "common-utils-i18n-locale-th" */ './locales/th')
  }
});

const commonT = i18n.getFixedT(null, null, 'common');
const supplyChainT = i18n.getFixedT(null, null, 'supplyChain');

export { i18n, commonT, supplyChainT };
